var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{staticClass:"song",style:(_vm.styleObject),attrs:{"cx":_vm.xPosition,"cy":_vm.yPosition,"r":_vm.radiusSize},on:{"click":function($event){_vm.displayModal()},"mouseenter":function($event){_vm.setStyleFilter($event)},"mouseleave":function($event){_vm.$emit('resetFilter')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd06a90c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Style.vue
// module id = null
// module chunks = 